module.exports = __webpack_public_path__ + "img/56.23faa9a2.jpg";